
export default function ExpertiseSection() {
  const expertise = [
    {
      title: 'AutoCAD Mastery',
      description: 'Advanced 2D and 3D design capabilities with 21+ years of specialized experience',
      icon: 'ri-pencil-ruler-2-line',
      stats: '300+ Projects',
    },
    {
      title: 'Revit Excellence',
      description: 'Building Information Modeling with parametric design and coordination expertise',
      icon: 'ri-building-3-line',
      stats: '150+ BIM Models',
    },
    {
      title: 'Dialux Proficiency',
      description: 'Professional lighting design and photometric analysis for optimal illumination',
      icon: 'ri-lightbulb-line',
      stats: '80+ Lighting Projects',
    },
    {
      title: 'Technical Documentation',
      description: 'Comprehensive floor plans, line diagrams, and engineering documentation',
      icon: 'ri-file-text-line',
      stats: '500+ Documents',
    }
  ];

  return (
    <section className="py-20 bg-[#dbcfbf]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-4">
            Our Technical Expertise
          </h2>
          <p className="text-xl text-[#889d8f] max-w-3xl mx-auto">
            Deep specialization across industry-leading design software and methodologies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {expertise.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-xl transition-all duration-300 group">
              <div className="relative h-20 overflow-hidden">
                <div className="absolute top-4 left-4 w-12 h-12 bg-[#e18033] rounded-lg flex items-center justify-center">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                </div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1">
                  <span className="text-sm font-semibold text-[#e18033]">{item.stats}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#212026] mb-3">{item.title}</h3>
                <p className="text-[#889d8f] leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-[#212026] mb-8">
            Professional Certifications & Standards
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="flex flex-col items-center p-4">
              <div className="w-16 h-16 bg-[#e18033] rounded-lg flex items-center justify-center mb-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-award-line text-white text-2xl"></i>
                </div>
              </div>
              <span className="text-sm font-medium text-[#889d8f]">AutoCAD Certified</span>
            </div>
            <div className="flex flex-col items-center p-4">
              <div className="w-16 h-16 bg-[#e18033] rounded-lg flex items-center justify-center mb-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-medal-line text-white text-2xl"></i>
                </div>
              </div>
              <span className="text-sm font-medium text-[#889d8f]">Revit Professional</span>
            </div>
            <div className="flex flex-col items-center p-4">
              <div className="w-16 h-16 bg-[#e18033] rounded-lg flex items-center justify-center mb-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
              </div>
              <span className="text-sm font-medium text-[#889d8f]">ISO 9001 Compliant</span>
            </div>
            <div className="flex flex-col items-center p-4">
              <div className="w-16 h-16 bg-[#e18033] rounded-lg flex items-center justify-center mb-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-building-line text-white text-2xl"></i>
                </div>
              </div>
              <span className="text-sm font-medium text-[#889d8f]">AIA Standards</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
